import { getOptimizedRoutes, getTripFareForDeliveryAddress, generateAddressFromCsv } from "./apiService"
import {validatePhoneNumber, validateAddress, validateNotEmpty} from "./validators"

export const handlerOptimizeRoute = async (checkedState, deliveryAddress, setDeliveryAdderss, priceDetails, setPriceDetails, myRef,
    setChecked) => {
    if (checkedState) {
        let oldAdd = {...deliveryAddress}
        let {places , oldDeliverAddress} = generatePlaceData(deliveryAddress)
        let response = await getOptimizedRoutes({
            data: places
        })
        let optimizedRoute = setOptimizedPlaceData(response.data, oldDeliverAddress)
        optimizedRoute.routeOptimized = true
      // setDeliveryAdderss(optimizedRoute)

      
      let tripPrice = await getTripFare(optimizedRoute)
      
      setPriceDetails({...priceDetails , tripFare:tripPrice.data.price[0].detail['9'].total , currency: tripPrice.data.currency })
      setDeliveryAdderss({...optimizedRoute,
      tripFare:tripPrice.data.price[0].detail['9'].total ,
      currency: tripPrice.data.currency, 
      priceId:tripPrice.data.priceID,
      duration:tripPrice.data.directions.duration ,
      distance: tripPrice.data.directions.distance,
      geometry: tripPrice.data.directions.geometry,
      errorMessage: '',
      validationPassed : true,
      goToPayment: true,
      calculateTripFare:false ,
      reoptimize : true,
      unoptimizedDeliveryDetails :  { ...oldAdd }   
      })
      
      sessionStorage.setItem("oldAddress", JSON.stringify({...oldAdd , routeOptimized:false}));
      
      // myRef.current = myRef.current + 1;
      setChecked(true)
      

    } else {
    
        if (deliveryAddress.unoptimizedDeliveryDetails && Object.keys(deliveryAddress.unoptimizedDeliveryDetails).length > 0) {
        // setDeliveryAdderss({...deliveryAddress.unoptimizedDeliveryDetails, routeOptimized:false, unoptimizedDeliveryDetails:{}, calculateTripFare:false }) JSON.parse(sessionStorage.getItem("deliveryAddresses"))
        // setDeliveryAdderss({...JSON.parse(sessionStorage.getItem("oldAdd")), routeOptimized:false, unoptimizedDeliveryDetails:{}, calculateTripFare:false }) 
        setDeliveryAdderss(() => {return {...deliveryAddress.unoptimizedDeliveryDetails, routeOptimized:false, unoptimizedDeliveryDetails:{}, calculateTripFare:false, goToPayment:true }})
        setPriceDetails({...priceDetails , tripFare:deliveryAddress.unoptimizedDeliveryDetails.tripFare , currency: deliveryAddress.unoptimizedDeliveryDetails.currency })
        }
        setChecked(false)
        
    }
    return true;
}

export const handleDeleteBooking = async (deliveryAddresses,setDeliveryAdderss, addressType, stopNumber) => {
    let currentDeliveryAddressess = {...deliveryAddresses}

            if (addressType === 'pickUpLocation') {
              currentDeliveryAddressess.pickUpLocation = { showEdit: false}
            } else if (addressType === 'dropOffLocation') {
              if (currentDeliveryAddressess.additionalStops && currentDeliveryAddressess.additionalStops.length > 0) {
                let additionalStops = [...currentDeliveryAddressess.additionalStops]
                currentDeliveryAddressess.dropOffLocation = additionalStops.shift()
                currentDeliveryAddressess.additionalStops = additionalStops
              } else {
                currentDeliveryAddressess.dropOffLocation = { showEdit: false}
              }
            } else {
              delete currentDeliveryAddressess.additionalStops[stopNumber]
              let newAdditionalStop = []
              for (let stop of currentDeliveryAddressess.additionalStops) {
                if (stop ) {
                  newAdditionalStop.push(stop)
                }
              }
              currentDeliveryAddressess.additionalStops = newAdditionalStop
            }
            
           // let tripPrice = await getTripFare({...currentDeliveryAddressess})
            // setPriceDetails({...priceDetails , tripFare:tripPrice.data.price[0].detail['9'].total , currency: tripPrice.data.currency })
            setDeliveryAdderss(()=> {return {...currentDeliveryAddressess,
                calculateTripFare:true ,
                }})
            // setDeliveryAdderss(currentDeliveryAddressess)

}

export const generatePlaceData = ( deliveryAddresses ) => {
    let places = []
    let oldDeliverAddress = []
    let pickupLocation = {
      latitude :deliveryAddresses.pickUpLocation.latitude,
      longitude : deliveryAddresses.pickUpLocation.longitude
    }
    places.push(pickupLocation)
    oldDeliverAddress.push(deliveryAddresses.pickUpLocation)

    let dropOffLocation = {
        latitude :deliveryAddresses.dropOffLocation.latitude,
        longitude : deliveryAddresses.dropOffLocation.longitude
    }
    places.push(dropOffLocation)
    oldDeliverAddress.push(deliveryAddresses.dropOffLocation)

    for (let address of deliveryAddresses.additionalStops) {
        let latlngData = {
          latitude :address.latitude,
          longitude : address.longitude
        }
        places.push(latlngData)
        oldDeliverAddress.push(address)
    }


    return { places , oldDeliverAddress }
}

export const setOptimizedPlaceData = ( newOptimizedDeliverAddress , oldDeliveryAddress ) => {

    let optimizedPlaces = {
        pickUpLocation : {

        },
        dropOffLocation : {

        }, 
        additionalStops: [

        ]
         
    }
    for (let i = 0 ; i < newOptimizedDeliverAddress.length ; i++) {
        if (i === 0) {
            //pickuplocation
            optimizedPlaces.pickUpLocation = oldDeliveryAddress[newOptimizedDeliverAddress[i].originalIndex]
            optimizedPlaces.pickUpLocation.showEdit = false
            continue
        }
        if (i === (newOptimizedDeliverAddress.length - 1)) {
            //dropOffLocation
            optimizedPlaces.dropOffLocation = oldDeliveryAddress[newOptimizedDeliverAddress[i].originalIndex]
            optimizedPlaces.dropOffLocation.showEdit = false
            continue
        }
        optimizedPlaces.additionalStops.push({...oldDeliveryAddress[newOptimizedDeliverAddress[i].originalIndex], showEdit:false})

    }
    return optimizedPlaces
}

export const getTripFare = async (deliveryAddress) => {
    let { oldDeliverAddress } = generatePlaceData(deliveryAddress)
    let response = await getTripFareForDeliveryAddress({data: oldDeliverAddress, startTime: [Date.now()]})
    return response
}

export const validateCsv = (parsedData) => {
    if (parsedData.length > 7) {
        throw Error("Users can only send maximum of 6 additional stops.")
    }
    for (let i = 0; i < parsedData.length ; i++) {
        // Validate Name
        if (!parsedData[0].name) {
            throw Error(`Invalid name at row ${i+1}`)
        }
        // Validate Postal
        if (!parsedData[0].postal || parsedData[0].postal.length !== 6) {
            throw Error(`Invalid postal code at row ${i+1}`)
        }
        // Validate Floor
        if (!parsedData[0].floor) {
            throw Error(`Invalid floor at row ${i+1}`)
        }
        // Validate Unit
        if (!parsedData[0].unit) {
            throw Error(`Invalid unit number at row ${i+1}`)
        }
        // Validate Phone number
        if (!parsedData[0].number || !validatePhoneNumber(parsedData[0].number)) {
            throw Error(`Invalid Phone number at row ${i+1}`)
        }
    }
    return
} 
export const getDeiveryAddressFromCsv = async(parsed, deliveryAddresses, setDeliveryAddress) => {
    let response = await generateAddressFromCsv(parsed)
    
    let generatedDeliveryAddress = {...deliveryAddresses} 
    if (response.status) {
       

        generatedDeliveryAddress.pickUpLocation = {...deliveryAddresses.pickUpLocation , ...response.data.pickUpLocation, showEdit:false}
        generatedDeliveryAddress.dropOffLocation = {...deliveryAddresses.dropOffLocation , ...response.data.dropOffLocation}
        generatedDeliveryAddress.additionalStops = [...response.data.additionalStops]
        generatedDeliveryAddress.goToPayment = true
        
        
        setDeliveryAddress(generatedDeliveryAddress)
        return response.status
    }
      
}

export const validateDeliveryAddressBeforeSubmit = ( deliveryDetails ) => {

    if(!deliveryDetails.pickUpLocation) {
        return {validationPassed: false, errorMessage: "Missing Pick location", issueAddressType: "pickUpLocation", issueInputType: "locationAddress" }
    }
    if(!validateAddress(deliveryDetails.pickUpLocation.latitude , deliveryDetails.pickUpLocation.latitude)) {
        return {validationPassed: false, errorMessage: "Invalid Pick Up address. Please select valid address from the dropdown", issueAddressType: "pickUpLocation", issueInputType: "latlng"}
    }
    if(!validatePhoneNumber(deliveryDetails.pickUpLocation.contactNumber)) {
        return {validationPassed: false, errorMessage: "Invalid Phone number" , issueAddressType: "pickUpLocation",  issueInputType: "contactNumber"}
    }
    if(!validateNotEmpty(deliveryDetails.pickUpLocation.contactName)) {
        return {validationPassed: false, errorMessage: "Invalid Contact Name" , issueAddressType: "pickUpLocation",  issueInputType: "contactName"}
    }
    if(!validateNotEmpty(deliveryDetails.pickUpLocation.unitNumber)) {
        return {validationPassed: false, errorMessage: "Invalid Unit number" , issueAddressType: "pickUpLocation",  issueInputType: "unitNumber"}
    }
    if(!validateNotEmpty(deliveryDetails.pickUpLocation.floor)) {
        return {validationPassed: false, errorMessage: "Invalid floor" , issueAddressType: "pickUpLocation",  issueInputType: "floor"}
    }

    // Validating Dropoff location

    if(!deliveryDetails.dropOffLocation) {
        return {validationPassed: false, errorMessage: "Missing Drop Off location", issueAddressType: "dropOffLocation", issueInputType: "locationAddress"}
    }
    if(!validateAddress(deliveryDetails.dropOffLocation.latitude , deliveryDetails.dropOffLocation.latitude)) {
        return {validationPassed: false, errorMessage: "Invalid Pickup address. Please select valid address from the dropdown", issueAddressType: "dropOffLocation", issueInputType:"latlng"}
    }
    if(!validatePhoneNumber(deliveryDetails.dropOffLocation.contactNumber)) {
        return {validationPassed: false, errorMessage: "Invalid Phone number dropoff location", issueAddressType: "dropOffLocation", issueInputType:"contactNumber"}
    }
    if(!validateNotEmpty(deliveryDetails.dropOffLocation.contactName)) {
        return {validationPassed: false, errorMessage: "Invalid contact name dropoff location", issueAddressType: "dropOffLocation", issueInputType:"contactName"}
    }
    if(!validateNotEmpty(deliveryDetails.dropOffLocation.unitNumber)) {
        return {validationPassed: false, errorMessage: "Invalid Unit number dropoff location", issueAddressType: "dropOffLocation", issueInputType:"unitNumber"}
    }
    if(!validateNotEmpty(deliveryDetails.dropOffLocation.floor)) {
        return {validationPassed: false, errorMessage: "Invalid floor", issueAddressType: "dropOffLocation", issueInputType:"floor"}
    }

    for (let i = 0; i < deliveryDetails.additionalStops.length ; i++) {
        
        let stop = {...deliveryDetails.additionalStops[i]}
        if(stop) {
            if(!validateAddress(stop.latitude , stop.latitude)) {
                return {validationPassed: false, errorMessage: `Invalid Pickup address at ${i+1} additional stop. Please select valid address from the dropdown`, issueAddressType: "additionalStop", issueAdditionalStopIndex:i, issueInputType: "latlng"}
            }
            if(!validatePhoneNumber(stop.contactNumber)) {
                return {validationPassed: false, errorMessage: `Invalid Phone number ${i+1} additional stop`,issueAddressType: "additionalStop", issueAdditionalStopIndex:i, issueInputType: "contactNumber"}
            }
            if(!validateNotEmpty(stop.contactName)) {
                return {validationPassed: false, errorMessage: `Invalid Contact name ${i+1}  additional stop`,issueAddressType: "additionalStop", issueAdditionalStopIndex:i, issueInputType: "contactName"}
            }
            if(!validateNotEmpty(stop.unitNumber)) {
                return {validationPassed: false, errorMessage: `Invalid Unit number ${i+1}  additional stop`,issueAddressType: "additionalStop", issueAdditionalStopIndex:i, issueInputType: "unitNumber"}
            }
            if(!validateNotEmpty(stop.floor)) {
                return {validationPassed: false, errorMessage: `Invalid Floor ${i+1}  additional stop`,issueAddressType: "additionalStop", issueAdditionalStopIndex:i, issueInputType: "floor"}
            }
        }

        
    }

    return {validationPassed: true, errorMessage: "" , issueAddressType: "",  issueInputType: ""}
}   

//address
//contactName
//contactNumber
//floor
//latitude
//longitude
//postalCode
//unitNumber